module.exports = __webpack_public_path__ + "img/update.3b9aedaa.png";